import { cn } from '~/utils/cnTailwind';

type Props = {
    // Loose shape: catalog preview and sent-message snapshot types both satisfy this.
    buttons: Array<{ text: string }>;
    className?: string;
};

// Display-only — a sent URL snapshot can carry the applicant's signed link; clicking it here would use their identity.
export const TemplateButtonsRow = ({ buttons, className }: Props) => {
    // An UNKNOWN button can have an empty label — it only holds its array position.
    const labelledButtons = buttons.filter((button) => button.text.length > 0);
    if (labelledButtons.length === 0) return null;

    return (
        <div
            className={cn('-mx-3 -mb-2 mt-2 space-y-2 border-t border-outline-light px-3 py-2', className)}
            data-testid="template-buttons-row"
        >
            {labelledButtons.map((button, index) => (
                <div key={index} className="rounded-lg bg-white px-3 py-2 text-center text-sm font-medium text-blue">
                    {button.text}
                </div>
            ))}
        </div>
    );
};
